import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:gap-x-[25px] lg:gap-[25px]" }
const _hoisted_2 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_3 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_4 = { class: "trezo-card-title" }
const _hoisted_5 = { class: "relative sm:w-[265px]" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_8 = { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_9 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_10 = {
  key: 0,
  class: "flex justify-center items-center p-8"
}
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center items-center p-8"
}
const _hoisted_12 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "text-black dark:text-white" }
const _hoisted_15 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_16 = { class: "form-check relative top-[2px]" }
const _hoisted_17 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_22 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_23 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_24 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_25 = { class: "text-black dark:text-white" }
const _hoisted_26 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_27 = { class: "form-check relative top-[2px]" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_31 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "rounded-md w-[40px] rounded-full" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_36 = { class: "block font-medium" }
const _hoisted_37 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_38 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_39 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_40 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_41 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_42 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_43 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_44 = { class: "flex items-center" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_48 = { class: "flex items-center gap-[9px]" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 2,
  type: "button",
  class: "text-gray-400 dark:text-gray-600 leading-none custom-tooltip cursor-not-allowed",
  id: "customTooltip",
  "data-text": "Closed - Cannot Process Payment"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_55 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-2 sm:mx-4 z-10 relative" }
const _hoisted_56 = { class: "flex justify-between items-center mb-5" }
const _hoisted_57 = { class: "flex justify-between items-center pt-3" }
const _hoisted_58 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_59 = { class: "bg-white dark:bg-[#0c1427] p-3 sm:p-6 rounded-lg shadow-lg w-full max-w-lg mx-2 sm:mx-4 z-10 relative overflow-y-auto max-h-[90vh]" }
const _hoisted_60 = { class: "flex justify-between items-center mb-4" }
const _hoisted_61 = {
  key: 0,
  class: "mb-4 space-y-3 sm:space-y-4"
}
const _hoisted_62 = { class: "flex flex-col sm:flex-row sm:items-center mb-3 sm:mb-4" }
const _hoisted_63 = ["src", "alt"]
const _hoisted_64 = { class: "text-lg sm:text-xl font-medium text-black dark:text-white" }
const _hoisted_65 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_66 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" }
const _hoisted_67 = { class: "text-black dark:text-white break-words" }
const _hoisted_68 = { class: "text-black dark:text-white" }
const _hoisted_69 = { class: "text-black dark:text-white" }
const _hoisted_70 = { class: "text-black dark:text-white" }
const _hoisted_71 = { class: "text-black dark:text-white" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "text-black dark:text-white whitespace-pre-line break-words" }
const _hoisted_74 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_75 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_76 = { class: "bg-white dark:bg-[#0c1427] p-3 sm:p-6 rounded-lg shadow-lg w-full max-w-lg mx-2 sm:mx-4 z-10 relative overflow-y-auto max-h-[90vh]" }
const _hoisted_77 = { class: "flex justify-between items-center mb-3 sm:mb-4" }
const _hoisted_78 = {
  key: 0,
  class: "mb-4 sm:mb-6"
}
const _hoisted_79 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" }
const _hoisted_80 = ["value"]
const _hoisted_81 = ["value"]
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { class: "relative" }
const _hoisted_84 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 pt-2 border-t border-gray-200 dark:border-[#172036] mt-4" }
const _hoisted_85 = { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_86 = ["type", "onUpdate:modelValue", "required"]
const _hoisted_87 = ["onUpdate:modelValue", "required"]
const _hoisted_88 = ["onUpdate:modelValue", "required"]
const _hoisted_89 = ["value"]
const _hoisted_90 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_91 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_92 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-2 sm:mx-4 z-10 relative" }
const _hoisted_93 = { class: "flex justify-between items-center mb-5" }
const _hoisted_94 = { class: "text-lg font-semibold text-black dark:text-white" }
const _hoisted_95 = { class: "mb-4" }
const _hoisted_96 = { class: "text-gray-700 dark:text-gray-300 mb-4" }
const _hoisted_97 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_98 = {
  key: 1,
  class: "max-h-[200px] overflow-y-auto border dark:border-[#172036] rounded-md"
}
const _hoisted_99 = ["onClick"]
const _hoisted_100 = { class: "mr-3 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white font-medium text-sm" }
const _hoisted_101 = { class: "font-medium text-black dark:text-white" }
const _hoisted_102 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_103 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RevenueGrowthChart = _resolveComponent("RevenueGrowthChart")!
  const _component_LeadConversionChart = _resolveComponent("LeadConversionChart")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_AnnualProfitChart = _resolveComponent("AnnualProfitChart")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RevenueGrowthChart, {
        "current-user-id": _ctx.currentUserId,
        "user-permissions": _ctx.userPermissions
      }, null, 8, ["current-user-id", "user-permissions"]),
      _createVNode(_component_LeadConversionChart, {
        "current-user-id": _ctx.currentUserId,
        "user-permissions": _ctx.userPermissions
      }, null, 8, ["current-user-id", "user-permissions"]),
      _createVNode(_component_TotalOrdersChart, {
        "current-user-id": _ctx.currentUserId,
        "user-permissions": _ctx.userPermissions
      }, null, 8, ["current-user-id", "user-permissions"]),
      _createVNode(_component_AnnualProfitChart, {
        "current-user-id": _ctx.currentUserId,
        "user-permissions": _ctx.userPermissions
      }, null, 8, ["current-user-id", "user-permissions"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _ctx.directT('crm.leads.searchLead'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
              class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.searchQuery]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
          }, [
            _createElementVNode("span", _hoisted_8, [
              _cache[32] || (_cache[32] = _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.leads.addNewLead')), 1)
            ])
          ]),
          (_ctx.selectedLeads.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white ml-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showBulkAssignModal && _ctx.showBulkAssignModal(...args)))
              }, _cache[33] || (_cache[33] = [
                _createElementVNode("span", { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " person_add "),
                  _createTextVNode(" " + _toDisplayString('Assign To'))
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[34] || (_cache[34] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500" }, null, -1)
            ])))
          : (_ctx.leads.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[35] || (_cache[35] = [
                _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "No leads found", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("thead", _hoisted_14, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "cursor-pointer",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ])
                        ])
                      ]),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('dashboard.id')), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('dashboard.customer')), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('common.email')), 1),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('common.phone')), 1),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('dashboard.crm.source')), 1),
                      _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('dashboard.status')), 1),
                      _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('todoList.assignedTo')), 1),
                      _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('dashboard.crm.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLeads, (lead) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: lead.id
                      }, [
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "cursor-pointer",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedLeads) = $event)),
                              value: lead.id
                            }, null, 8, _hoisted_28), [
                              [_vModelCheckbox, _ctx.selectedLeads]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getShortId(lead.id)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("img", {
                                src: _ctx.getLeadImageUrl(lead),
                                class: "inline-block rounded-full",
                                alt: "lead-image"
                              }, null, 8, _hoisted_34)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("span", _hoisted_36, _toDisplayString(lead.name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(lead.email), 1),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(lead.phone), 1)
                        ]),
                        _createElementVNode("td", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(lead.source), 1)
                        ]),
                        _createElementVNode("td", _hoisted_42, [
                          _createElementVNode("span", {
                            class: "px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs",
                            style: _normalizeStyle(_ctx.getStatusClass(lead.status))
                          }, _toDisplayString(lead.status || 'Close'), 5)
                        ]),
                        _createElementVNode("td", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            (lead.assigned_to)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "text-primary-500 dark:text-primary-400 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.showAssignModal(lead))
                                }, _toDisplayString(_ctx.getAssignedUserName(lead)), 9, _hoisted_45))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "text-gray-500 dark:text-gray-400 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.showAssignModal(lead))
                                }, _cache[36] || (_cache[36] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md mr-1 align-text-bottom" }, "person_add", -1),
                                  _createTextVNode(" Assign ")
                                ]), 8, _hoisted_46))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-primary-500 leading-none custom-tooltip",
                              id: "customTooltip",
                              "data-text": "View",
                              onClick: ($event: any) => (_ctx.viewLead(lead))
                            }, _cache[37] || (_cache[37] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                            ]), 8, _hoisted_49),
                            (_ctx.userPermissions.is_owner || _ctx.userPermissions.edit_all_leads || lead.assigned_to === _ctx.currentUserId)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                                  id: "customTooltip",
                                  "data-text": "Edit",
                                  onClick: ($event: any) => (_ctx.editLead(lead))
                                }, _cache[38] || (_cache[38] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                                ]), 8, _hoisted_50))
                              : _createCommentVNode("", true),
                            ((_ctx.userPermissions.is_owner || _ctx.userPermissions.edit_all_leads || lead.assigned_to === _ctx.currentUserId) && (!lead.status || lead.status.toLowerCase() !== 'close'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "text-success-500 leading-none custom-tooltip",
                                  id: "customTooltip",
                                  "data-text": "Payment",
                                  onClick: ($event: any) => (_ctx.handlePayment(lead))
                                }, _cache[39] || (_cache[39] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " payments ", -1)
                                ]), 8, _hoisted_51))
                              : ((_ctx.userPermissions.is_owner || _ctx.userPermissions.edit_all_leads || lead.assigned_to === _ctx.currentUserId) && lead.status && lead.status.toLowerCase() === 'close')
                                ? (_openBlock(), _createElementBlock("button", _hoisted_52, _cache[40] || (_cache[40] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " payments ", -1)
                                  ])))
                                : _createCommentVNode("", true),
                            (_ctx.userPermissions.is_owner || _ctx.userPermissions.edit_all_leads || lead.assigned_to === _ctx.currentUserId)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  type: "button",
                                  class: "text-danger-500 leading-none custom-tooltip",
                                  id: "customTooltip",
                                  "data-text": "Delete",
                                  onClick: ($event: any) => (_ctx.deleteLead(lead))
                                }, _cache[41] || (_cache[41] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                                ]), 8, _hoisted_53))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
        _createVNode(_component_Pagination, {
          items: _ctx.itemsPerPage,
          total: _ctx.filteredLeads.length,
          "current-page": _ctx.currentPage,
          onPageChange: _ctx.handlePageChange,
          class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
        }, null, 8, ["items", "total", "current-page", "onPageChange"])
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "text-lg font-semibold text-black dark:text-white" }, "Confirm Deletion", -1)),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[42] || (_cache[42] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "mb-6" }, [
              _createElementVNode("p", { class: "text-gray-700 dark:text-gray-300 text-sm sm:text-base" }, " Are you sure you want to delete this lead? This action cannot be undone. ")
            ], -1)),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "inline-block py-[10px] px-[20px] bg-gray-400 text-white transition-all hover:bg-gray-500 rounded-md border border-gray-400 hover:border-gray-500"
              }, _cache[44] || (_cache[44] = [
                _createElementVNode("span", { class: "flex items-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined mr-2" }, "close"),
                  _createTextVNode(" Cancel ")
                ], -1)
              ])),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "inline-block py-[10px] px-[20px] bg-danger-500 text-white transition-all hover:bg-danger-400 rounded-md border border-danger-500 hover:border-danger-400"
              }, _cache[45] || (_cache[45] = [
                _createElementVNode("span", { class: "flex items-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined mr-2" }, "delete"),
                  _createTextVNode(" Delete ")
                ], -1)
              ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "text-lg font-medium text-black dark:text-white" }, "Lead Details", -1)),
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[47] || (_cache[47] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            (_ctx.leadToView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("img", {
                      src: _ctx.getLeadImageUrl(_ctx.leadToView),
                      class: "w-14 h-14 sm:w-16 sm:h-16 rounded-full mb-2 sm:mb-0 sm:mr-4",
                      alt: _ctx.leadToView.name
                    }, null, 8, _hoisted_63),
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", _hoisted_64, _toDisplayString(_ctx.leadToView.name), 1),
                      _createElementVNode("p", _hoisted_65, "ID: " + _toDisplayString(_ctx.getShortId(_ctx.leadToView.id)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", null, [
                      _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Email", -1)),
                      _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.leadToView.email), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Phone", -1)),
                      _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.leadToView.phone || 'N/A'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Company", -1)),
                      _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.getCompanyName(_ctx.leadToView)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Source", -1)),
                      _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.leadToView.source), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Status", -1)),
                      _createElementVNode("p", null, [
                        _createElementVNode("span", {
                          class: "px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs",
                          style: _normalizeStyle(_ctx.getStatusClass(_ctx.leadToView.status))
                        }, _toDisplayString(_ctx.leadToView.status || 'Close'), 5)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Created Date", -1)),
                      _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.formatDate(_ctx.leadToView.created_at)), 1)
                    ])
                  ]),
                  (_ctx.leadToView.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }, "Notes", -1)),
                        _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.leadToView.notes), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "px-3 py-2 sm:px-4 text-sm bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
              }, " Close "),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editLead(_ctx.leadToView))),
                class: "px-3 py-2 sm:px-4 text-sm bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all"
              }, " Edit ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args)))
          }),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _cache[57] || (_cache[57] = _createElementVNode("h3", { class: "text-lg font-medium text-black dark:text-white" }, "Edit Lead", -1)),
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[56] || (_cache[56] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            (_ctx.leadToEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _createElementVNode("form", {
                    onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateLead && _ctx.updateLead(...args)), ["prevent"])),
                    class: "space-y-3 sm:space-y-4"
                  }, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", null, [
                        _cache[58] || (_cache[58] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.leadToEdit.name) = $event)),
                          required: "",
                          class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                        }, null, 512), [
                          [_vModelText, _ctx.leadToEdit.name]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Email", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.leadToEdit.email) = $event)),
                          required: "",
                          class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                        }, null, 512), [
                          [_vModelText, _ctx.leadToEdit.email]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Phone", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.leadToEdit.phone) = $event)),
                          class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                        }, null, 512), [
                          [_vModelText, _ctx.leadToEdit.phone]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[62] || (_cache[62] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Status", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.leadToEdit.status) = $event)),
                          required: "",
                          class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                        }, [
                          _cache[61] || (_cache[61] = _createElementVNode("option", {
                            value: "",
                            disabled: ""
                          }, "Select", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: status.id,
                              value: status.name
                            }, _toDisplayString(status.name), 9, _hoisted_80))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.leadToEdit.status]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[64] || (_cache[64] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Source", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.leadToEdit.source) = $event)),
                          required: "",
                          class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                        }, [
                          _cache[63] || (_cache[63] = _createElementVNode("option", {
                            value: "",
                            disabled: ""
                          }, "Select", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: source.id,
                              value: source.name
                            }, _toDisplayString(source.name), 9, _hoisted_81))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.leadToEdit.source]
                        ])
                      ]),
                      (_ctx.leadToEdit.status && _ctx.leadToEdit.status.toLowerCase() === 'close')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _cache[66] || (_cache[66] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Income", -1)),
                            _createElementVNode("div", _hoisted_83, [
                              _cache[65] || (_cache[65] = _createElementVNode("span", { class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" }, "$", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.leadToEdit.dealamount) = $event)),
                                placeholder: "0.00",
                                min: "0",
                                step: "0.01",
                                class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] pl-7 pr-[14px] sm:pr-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                              }, null, 512), [
                                [_vModelText, _ctx.leadToEdit.dealamount]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _cache[68] || (_cache[68] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700 dark:text-gray-300 sm:col-span-2 mb-2" }, "Custom Fields", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields.filter(f => f.required), (field) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: field.key,
                          class: _normalizeClass(["mb-1", {'sm:col-span-2': field.type === 'textarea'}])
                        }, [
                          _createElementVNode("label", _hoisted_85, _toDisplayString(field.label) + " " + _toDisplayString(field.required ? '*' : ''), 1),
                          (_ctx.getInputType(field.type) !== 'select' && field.type !== 'textarea')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: _ctx.getInputType(field.type),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                required: field.required,
                                class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                              }, null, 8, _hoisted_86)), [
                                [_vModelDynamic, _ctx.customFieldValues[field.key]]
                              ])
                            : (field.type === 'textarea')
                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                  required: field.required,
                                  rows: "3",
                                  class: "rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] py-[10px] sm:py-[12px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                                }, null, 8, _hoisted_87)), [
                                  [_vModelText, _ctx.customFieldValues[field.key]]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                  required: field.required,
                                  class: "h-[40px] sm:h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                                }, [
                                  _cache[67] || (_cache[67] = _createElementVNode("option", { value: "" }, "Select", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option,
                                      value: option
                                    }, _toDisplayString(option), 9, _hoisted_89))
                                  }), 128))
                                ], 8, _hoisted_88)), [
                                  [_vModelSelect, _ctx.customFieldValues[field.key]]
                                ])
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("div", null, [
                      _cache[69] || (_cache[69] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Notes", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.leadToEdit.notes) = $event)),
                        rows: "3",
                        class: "rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] sm:px-[17px] py-[10px] sm:py-[12px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                      }, null, 512), [
                        [_vModelText, _ctx.leadToEdit.notes]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args))),
                        class: "px-3 py-2 sm:px-4 text-sm bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
                      }, " Cancel "),
                      _cache[70] || (_cache[70] = _createElementVNode("button", {
                        type: "submit",
                        class: "px-3 py-2 sm:px-4 text-sm bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all"
                      }, " Save Changes ", -1))
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md p-4 rounded-md shadow-lg transform transition-transform duration-300 z-50 flex items-center justify-between", { 
      'bg-green-600 text-white': _ctx.toastType === 'success', 
      'bg-red-600 text-white': _ctx.toastType === 'error', 
      'bg-blue-600 text-white': _ctx.toastType === 'info' 
    }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.toastMessage), 1),
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
            class: "ml-4 text-white hover:text-gray-300"
          }, "×")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showingAssignModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args)))
          }),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("h3", _hoisted_94, _toDisplayString(_ctx.isBulkAssign ? `Assign ${_ctx.selectedLeads.length} Selected Leads` : 'Assign Lead'), 1),
              _createElementVNode("button", {
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[71] || (_cache[71] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.isBulkAssign ? 'Select a user to assign these leads to:' : `Assigning lead: ${_ctx.leadToAssign?.name || ''}`), 1),
              (_ctx.loadingUsers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, _cache[72] || (_cache[72] = [
                    _createElementVNode("div", { class: "inline-block animate-spin rounded-full border-4 border-primary-500 border-t-transparent h-8 w-8" }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user.user_id,
                        onClick: ($event: any) => (_ctx.isBulkAssign ? _ctx.assignSelectedLeads(user.user_id) : _ctx.assignLead(user.user_id)),
                        class: "p-3 hover:bg-gray-100 dark:hover:bg-[#172036] cursor-pointer border-b last:border-b-0 dark:border-[#172036] transition-colors flex items-center"
                      }, [
                        _createElementVNode("div", _hoisted_100, _toDisplayString(user.display_name ? user.display_name.substring(0, 1).toUpperCase() : user.email.substring(0, 1).toUpperCase()), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_101, _toDisplayString(user.display_name || user.email), 1),
                          _createElementVNode("p", _hoisted_102, _toDisplayString(user.email), 1)
                        ])
                      ], 8, _hoisted_99))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args))),
                class: "px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
              }, " Cancel "),
              (_ctx.currentUserId && !_ctx.isBulkAssign)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.assignLead(null))),
                    class: "px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md transition-all"
                  }, " Unassign "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}